import axios from 'axios' // 引入axios
import router from '../router/index' // 引入路由
import qs from 'qs' //引入qs，做post传参格式转换
// import querystring from 'querystring'   // querystring 转化参数在后台表单格式提交时需要使用

let cancel, promiseArr = {}
const CancelToken = axios.CancelToken;

// "响应" 拦截器即异常处理 
axios.interceptors.response.use(response => {
  let list = response.data.list; // 根据实际数据结构取得返回的token
  return response;
}, err => {
  // 请求的错误判断,根据不同的错误码不同消息提醒
  if (err && err.response) {
      console.log('we have error')
      console.log(err.response)
      console.log(this)
      if(err.response.data.errCode==-9999){
        var currentUrl= window.location.href; 
        var activityId = ''
        if(currentUrl.indexOf("/hjmb") != -1){
          activityId = 'hjmb'
        }
        if(currentUrl.indexOf("/kfhd") != -1){
          activityId = 'kfhd'
        }
        /////////////徒步答题活动start//////////////////
        if(currentUrl.indexOf("/tbdt") != -1){
          activityId = 'tbdt'
        }
        /////////////徒步答题活动end//////////////////
        window.location.href = '/jy-act/'+activityId+'/baoming'
        // if(router.path != '/index/person'){
          // router.push({
          //   path: '',
          // })
        // }
      }
  } else {
    err.message = "连接到服务器失败"
  }
  return Promise.resolve(err.response)
})

// 设置默认   //config/index.js中设置了代理处理跨域请求，
// var domain = window.location.protocol + "//" + window.location.host;
// axios.defaults.baseURL = domain +'/rs/'; // 请求的公共地址(例如：api.XXX.com)

// 设置默认请求头
// axios.defaults.headers = {
//   "content-type": "application/x-www-form-urlencoded", // 设置传输类型(json,form表单)
// }

axios.defaults.timeout = 10000 // 响应时间

// 各种请求方式,仿照get的方式写即可
export default {
  //get请求
  get(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        params: param,
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        resolve(res.data)
        // return res.data
      })
    })
  },
  getAddTicket(url, param) {
    return new Promise((resolve, reject) => {
      param.ticket = sessionStorage.getItem('ticket')
      axios({
        method: 'get',
        url: url,
        params: param,
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        resolve(res.data)
        // return res.data
      })
    })
  },
  postAddTicket(url, param) {
    return new Promise((resolve, reject) => {
      param.ticket = sessionStorage.getItem('ticket')
      axios({
        method: 'post',
        url: url,
        data: param,
        header:{
          'Content-Type':'application/json'
          },
        cancelToken: new CancelToken(c => {
          cancel = c
        }),
      }).then(res => {
        resolve(res.data)
      })
    })
  },
  post(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        data: param,
        header:{
          'Content-Type':'application/json'
          },
        cancelToken: new CancelToken(c => {
          cancel = c
        }),
      }).then(res => {
        resolve(res.data)
      })
    })
  },
  //post请求提交文件
  postFile(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: this.addFileTicket(url),
        data: param,
        cancelToken: new CancelToken(c => {
          cancel = c
        }),
      }).then(res => {
        resolve(res.data)
      })
    })
  },
  put(url, param) {},
  delete(url, param) {},
  // 请求携带ticket
  addTicket(param) {
    let ticket;
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf('ticket=') == 0) ticket = c.substring('ticket='.length, c.length);
    }
    let data;
    if (!param) {
      data = {
        ticket: ticket
      }
    } else if (param.userId) {
      data = param
    } else {
      data = param
      data.ticket = ticket
    }
    console.log(data)
    return data;
  },
  // 请求携带ticket
  addFileTicket(url) {
    let ticket;
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf('ticket=') == 0) ticket = c.substring('ticket='.length, c.length);
    }
    let data;
    url = url + '?ticket=' + ticket
    return url;
  },
  axiosAll(param1,param2,fun3){
    axios.all([this.axiosAllFun1(param1),this.axiosAllFun2(param2)])
    .then(axios.spread(function(a,b){
      fun3(a.data,b.data)
    }))
  },
  axiosAllFun1(param){
    return axios({
      method: param.method,
      url: param.url,
      params: param.sendData,
    })
  },
  axiosAllFun2(param){
    return axios({
      method: param.method,
      url: param.url,
      params: param.sendData,
    })
  },
};



// WEBPACK FOOTER //
// ./src/utils/axios.js